export const PRODUCTS_ACTIONS_TYPES = {
	SET_PRODUCTS: "sellers/SET_PRODUCTS",
	SET_KIT: "sellers/SET_KIT",
	SET_SELLERS_KIT: 'sellers/SET_SELLERS_KIT'
};
